import React from 'react';

export default function Icon({onClick, children, className}) {
    return (
        <div className='setting-icon' onClick={onClick} id="join-button">
            {children}
        </div>
    );
}
